import RecusaPanel from './RecusaPanel';

export default RecusaPanel;
